import { render } from "./TextBubble.vue?vue&type=template&id=6db7baba"
import script from "./TextBubble.vue?vue&type=script&lang=js"
export * from "./TextBubble.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__